// ✅ BetAmountPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket } from "../api";
import LoadingPage from "./LoadingPage";
import DigitalTimer from "./DigitalTimer";

const BetAmountPage = () => {

  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-sine" });

    // 🔁 Always request full room list on mount
    socket.emit("get-rooms");

    // ✅ FULL SNAPSHOT (authoritative)
    socket.on("room-list", (list) => {
      setRooms((prev) => {
        // First load → sort and set
        if (prev.length === 0) {
          return [...list].sort((a, b) => Number(a.id) - Number(b.id));
        }
    
        // After first load → MERGE only (no replace, no sort)
        return prev.map((room) => {
          const fresh = list.find((r) => r.roomId === room.roomId);
          return fresh ? { ...room, ...fresh } : room;
        });
      });
    
      setLoading(false);
    });    
  
    // ✅ SINGLE ROOM UPDATE (authoritative)
    socket.on("room-update", (updatedRoom) => {
      setRooms((prev) =>
        prev.map((room) =>
          room.roomId === updatedRoom.roomId
            ? { ...room, ...updatedRoom }
            : room
        )
      );
    });
    
    
    // 🔄 Safety sync every second (prevents stale UI)
    const syncInterval = setInterval(() => {
      socket.emit("get-rooms");
    }, 1000);

    return () => {
      socket.off("room-list");
      socket.off("room-update");
      clearInterval(syncInterval);
    };
  }, []);

  const handleJoinClick = (room) => {
    if (room.status === "playing") {
      navigate("/play", {
        state: {
          roomInfo: room,
        },
      });
    } else {
      navigate(
        `/select-cards?room=${room.roomId}&stake=${room.amount}&win=${room.winAmount}`,
      );
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="min-h-screen bg-[#082f52] text-white">
    <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900">
      <Navbar2 />
    </div>
  
    <div className="text-center pt-20">
      <h1 className="text-2xl font-semibold font-serif">የጨዋታ መደብ ይምረጡ</h1>
    </div>
  
    <div className="mt-10 flex justify-center">
      {/* ✅ Outer container glow */}
      <div
        className="w-full max-w-4xl rounded-lg overflow-hidden shadow-xl px-1"
      >
        {/* ✅ Header as card */}
        <div
          className="
          grid grid-cols-4 text-center font-semibold py-4 mb-3
          rounded-xl
          bg-[#273e60]
          border border-white/10
          shadow-md
          font-serif
        "
        >
          <div>መደብ</div>
          <div>የጨዋታ ሁኔታ</div>
          <div>ደራሽ</div>
          <div>Join</div>
        </div>
  
        {rooms.map((room) => {
          return (
            <div
              key={room.roomId}
              className="
              grid grid-cols-4 text-center items-center
              py-1 my-3
              rounded-xl
              bg-gradient-to-r from-[#2d4f73] to-[#3a5f86]
              shadow-[0_8px_20px_rgba(0,0,0,0.45)]
              border border-white/10
              hover:scale-[1.01] transition
              font-serif
            "
            >
              <div>{room.amount} ብር</div>
  
              <div className="text-sm">
                {room.status === "counting" ? (
                  <DigitalTimer seconds={room.countdown} />
                ) : room.status === "playing" ? (
                  <span className="text-green-400">Playing</span>
                ) : (
                  <span className="text-gray-300">Waiting</span>
                )}
              </div>
  
              <div>{room.winAmount ? `${room.winAmount} Birr` : "—"}</div>
  
              <div>
                <button
                  onClick={() => handleJoinClick(room)}
                  className={`px-4 py-2 rounded-lg font-semibold ${
                    room.status === "playing"
                      ? "bg-gray-600"
                      : "bg-gradient-to-r from-[#4e6d8c] to-[#6784a4] hover:opacity-90"
                  }`}
                >
                  {room.status === "playing" ? "Open »" : "» Join"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
  
  );
};

export default BetAmountPage;
